import { render, staticRenderFns } from "./HouseholdDashboard.vue?vue&type=template&id=17aa0024&scoped=true"
import script from "./HouseholdDashboard.vue?vue&type=script&lang=js"
export * from "./HouseholdDashboard.vue?vue&type=script&lang=js"
import style0 from "./HouseholdDashboard.vue?vue&type=style&index=0&id=17aa0024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aa0024",
  null
  
)

export default component.exports